<template>
    <div class="m-header" id="m-header" v-if="setup != null">
        <div class="bazis-logo">
            <a :href="setup.logo_bazis.link" target="_blank">
                <img :src="setup.logo_bazis.img" alt="">
                <img :src="setup.logo_bazis_white" class="logo-white" alt="">
            </a>
        </div>
        <div class="main-logo">
            <a href="#" v-scroll-to="{
                    el: 'body',
                    offset: 0
            }">
                <img :src="setup.logo" alt="">
                <img :src="setup.logo_white" class="logo-white" alt="">
            </a>
        </div>
        <div class="mobile-menu" :class="{open: isOpenSendwich}" @click="openMobileMenu(!isOpenSendwich)">
            <span></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'mobileHeader',
        components: {
        },
        data () {
            return {
                openMenu: this.isOpenSendwich
            }
        },
        methods: {
            openFormModal() {
                this.$store.commit('Open_Form_Modal', true);
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                if (data === true) {
                    // document.getElementById('secret-btns').classList.remove('fadeIn');
                } else {
                    if (window.scrollY >= window.innerHeight) {
                        // document.getElementById('secret-btns').classList.add('fadeIn');
                    }
                }
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            },
            isOpenSendwich() {
                return this.$store.state.isOpenSendwich
            }
        },
        created () {
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.pageSetup,
            //     (newValue) => {
            //         if (newValue.main_page_navigation.length >= 5) {
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/m-header.scss';
    // @import '@/styles/components/nav-main/nav-main.scss';
</style>